import { materialBaseLimits } from "shared-logic-core";
import { z } from "zod";

import { MaterialPriceAlertSchema } from "./MaterialPriceAlert";
import { JobStatusSchema } from "./PrismaZod";

export const MATERIAL_LIST_MAX_ROWS = materialBaseLimits.max_rows;

export const MaterialStructureImportIssueSchema = z.object({
  sheet: z.string().nullable(),
  row: z.number(),
  label: z.string().nullable(),
  codes: z.array(z.string()),
  materialId: z.string().uuid().nullable(),
});

export type MaterialStructureImportIssue = z.infer<typeof MaterialStructureImportIssueSchema>;

export const MaterialStructureImportFailureCodeSchema = z.enum([
  "UNREADABLE_FILE",
  "MISSING_COLUMNS",
  "TOO_MANY_ROWS",
  "REJECTED_ROWS",
  "JOB_FAILED",
]);

export type MaterialStructureImportFailureCode = z.infer<
  typeof MaterialStructureImportFailureCodeSchema
>;

export const MaterialStructureImportResultSchema = z.discriminatedUnion("outcome", [
  z.object({
    outcome: z.literal("imported"),
    importedCount: z.number(),
    skipped: z.array(MaterialStructureImportIssueSchema),
    warnings: z.array(MaterialStructureImportIssueSchema),
    priceAlerts: z.array(MaterialPriceAlertSchema),
  }),
  z.object({
    outcome: z.literal("failed"),
    failureCode: MaterialStructureImportFailureCodeSchema,
    missingFields: z.array(z.string()),
    errors: z.array(MaterialStructureImportIssueSchema),
  }),
]);

export type MaterialStructureImportResult = z.infer<typeof MaterialStructureImportResultSchema>;

export const MaterialStructureImportSchema = z.object({
  jobId: z.string().uuid(),
  status: JobStatusSchema,
  result: MaterialStructureImportResultSchema.nullable(),
});

export type MaterialStructureImport = z.infer<typeof MaterialStructureImportSchema>;
